import React from 'react'
import { useEffect } from 'react';
import { useDispatch , useSelector} from "react-redux";
import { Link } from 'react-router-dom';
import { authActions } from "../../store/auth";

const Bump = () => {
    const dispatch = useDispatch();
    //   const access = useSelector((state) => state.auth.access);

    useEffect(() => {
        dispatch(authActions.setLoaderStatus({ status: false }));
    });

  const meta_data = useSelector(state => state.auth.product.meta_data)
  const logo = meta_data && JSON.parse(meta_data).subdomainLogo ? JSON.parse(meta_data).subdomainLogo : '';

  return (
    <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Bump
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="bx_a">
                <div className="emptyDiv">
                  { logo && <img
                    src={logo}
                    className="img-fluid"
                    alt="img"
                    />
                  }
                  <br />
                  <h4 className="mb-4">Cold Reachout Templates</h4>
                  
                  <a
                    className="btn mt-3"
                    href="https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/10+Completely+DFY+Reachout+Email+(VidAmaze).pdf"
                    target="_blank"
                    rel="noreferrer"
                    download={true}
                  >
                    Click here to access Cold Reachout Templates
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default Bump